import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import React from 'react';
import Tplink from '../../../assets/images/tplink.jpg';
import Zte from '../../../assets/images/zte.jpg';
import Huawei from '../../../assets/images/huawei.jpg';
import Greatek from '../../../assets/images/greatek.jpg';
import Tplink1200 from '../../../assets/images/TPLINK_EC220_G5.jpg';
import Tplink840 from '../../../assets/images/TPLINK_WR840NV6.jpg';

import Datacom from '../../../assets/images/datacom.jpg';
import Tenda from '../../../assets/images/tenda.jpg';
import Modal from 'react-bootstrap/Modal';
import ListGroup from 'react-bootstrap/ListGroup';
import { useState } from 'react';

import * as FaIcons from "react-icons/fa";
import * as AiIcons from "react-icons/ai";


import './styles.css';


const Especificacoes = () => {

    const [showModalA, setShowModalA] = useState(false);
    const [showModalB, setShowModalB] = useState(false);
    const [showModal1, setShowModal1] = useState(false);
    const [showModal2, setShowModal2] = useState(false);
    const [showModal3, setShowModal3] = useState(false);
    const [showModal4, setShowModal4] = useState(false);
    const [showModal5, setShowModal5] = useState(false);
    const [showModal6, setShowModal6] = useState(false);


    const handleCloseModalA = () => setShowModalA(false);
    const handleCloseModalB = () => setShowModalB(false);
    const handleCloseModal1 = () => setShowModal1(false);
    const handleCloseModal2 = () => setShowModal2(false);
    const handleCloseModal3 = () => setShowModal3(false);
    const handleCloseModal4 = () => setShowModal4(false);
    const handleCloseModal5 = () => setShowModal5(false);
    const handleCloseModal6 = () => setShowModal6(false);

    const handleOpenModalA = () => setShowModalA(true);
    const handleOpenModalB = () => setShowModalB(true);
    const handleOpenModal1 = () => setShowModal1(true);
    const handleOpenModal2 = () => setShowModal2(true);
    const handleOpenModal3 = () => setShowModal3(true);
    const handleOpenModal4 = () => setShowModal4(true);
    const handleOpenModal5 = () => setShowModal5(true);
    const handleOpenModal6 = () => setShowModal6(true);

    return (
        <>
             <Card className='altura'>
                <Card.Title>

                    <h1>Dúvidas frequentes sobre Roteadores</h1>

                </Card.Title>

                <Card.Body>
                    <div className='basic-card px-2'>
                        <div className='row  py-4'>
                            <div className='col-sm-12 col-md-6'>
                                <Card>
                                    <Card.Header className="w-100"><AiIcons.AiFillSignal /> TP-Link TL-WR840N Wireless  </Card.Header>
                                    <Card.Body>
                                        <Card.Title><FaIcons.FaStackOverflow /> Informações básicas: </Card.Title>
                                        <Card.Text>
                                            <div className='router'>
                                                <span className='imagem'><img src={Tplink840} alt="Foto" /></span>
                                                <span className='marca'>
                                                    <ul>
                                                        <li>Indicado para velocidade de conexões de até 100 megas(rede cabeada) </li>
                                                        <li>Ethernet: 1 Porta WAN, 4 Portas LAN RJ-45 10/100Mbps.</li>
                                                        <li>Adaptador AC: 9VDC/0.6A</li>
                                                    </ul>
                                                </span>
                                            </div>
                                        </Card.Text>
                                        <Button onClick={handleOpenModalA}>+ Informações</Button>
                                        <Modal show={showModalA} onHide={handleCloseModalA} size="lg" className="custom-modal">
                                            <Modal.Header closeButton>
                                                <Modal.Title>Informações úteis sobre roteador TP-Link TL-WR840N com PRESET</Modal.Title>
                                            </Modal.Header>
                                            <Modal.Body>
                                                <ListGroup as="ol">
                                                    <ListGroup.Item as="li">IP padrão: 192.168.0.1</ListGroup.Item>
                                                    <ListGroup.Item as="li">Usuário: admin | senha: admin</ListGroup.Item>
                                                    <ListGroup.Item as="li">Wi-fi: TP-Link_DF56</ListGroup.Item>
                                                    <ListGroup.Item as="li">Senha: 50055524</ListGroup.Item>
                                                </ListGroup>
                                                <br />
                                                <h5>Recomendações:</h5>
                                                <ListGroup as="ol">
                                                    <ListGroup.Item as="li">DHCP ativado</ListGroup.Item>
                                                    <ListGroup.Item as="li">Conexão com ONU na WAN do roteador</ListGroup.Item>
                                                    <ListGroup.Item as="li">Teste de velocidade Wifi realizados em bancada 50 megas</ListGroup.Item>
                                                    <ListGroup.Item as="li"><Card.Link href="https://emulator.tp-link.com/Emulator_TL-WR840N(BR)6.20/index.htm" target="_blank">Emulador</Card.Link></ListGroup.Item>
                                                </ListGroup>
                                            </Modal.Body>
                                            <Modal.Footer>
                                                <Button variant="dark" onClick={handleCloseModalA}>
                                                    Fechar
                                                </Button>
                                            </Modal.Footer>
                                        </Modal>
                                        <Card.Link href="https://static.tp-link.com/2018/201809/20180926/TL-WR840N%206.20%20Datasheet.pdf" target="_blank"> <Button variant="dark">Especificações Técnicas </Button> </Card.Link>
                                    </Card.Body>
                                </Card>
                            </div>
                            <div className='col-sm-12 col-md-6'>
                                <Card>
                                    <Card.Header className="w-100"><AiIcons.AiFillSignal /> TP-Link AC750 Wireless Dual Band Router Archer C20 </Card.Header>
                                    <Card.Body>
                                        <Card.Title><FaIcons.FaStackOverflow /> Informações básicas: </Card.Title>
                                        <Card.Text>
                                            <div className='router'>
                                                <span className='imagem'><img src={Tplink} alt="Foto" /></span>
                                                <span className='marca'>
                                                    <ul>
                                                        <li>Indicado para velocidade de conexões de até 100 megas(rede cabeada) </li>
                                                        <li>Ethernet: 1 Porta WAN, 4 Portas LAN RJ-45 10/100Mbps.</li>
                                                        <li>Adaptador AC: 9VDC/0.6A</li>
                                                        <li>Dual Signal Rate: 5GHz e 2.4GHz</li>
                                                    </ul>
                                                </span>
                                            </div>
                                        </Card.Text>
                                        <Button onClick={handleOpenModalB}>+ Informações</Button>
                                        <Modal show={showModalB} onHide={handleCloseModalB} size="lg" className="custom-modal">
                                            <Modal.Header closeButton>
                                                <Modal.Title>Informações úteis sobre roteador TP-Link C20 com PRESET</Modal.Title>
                                            </Modal.Header>
                                            <Modal.Body>
                                                <ListGroup as="ol">
                                                    <ListGroup.Item as="li">IP padrão: 192.168.0.1</ListGroup.Item>
                                                    <ListGroup.Item as="li">Usuário: admin | senha: admin</ListGroup.Item>
                                                    <ListGroup.Item as="li">Wi-fi: TP-Link_DF56</ListGroup.Item>
                                                    <ListGroup.Item as="li">Senha: 50055524</ListGroup.Item>
                                                    <ListGroup.Item as="li">Wi-fi: TP-Link_DF56_5G</ListGroup.Item>
                                                    <ListGroup.Item as="li">Senha: 50055524</ListGroup.Item>
                                                </ListGroup>
                                                <br />
                                                <h5>Recomendações:</h5>
                                                <ListGroup as="ol">
                                                    <ListGroup.Item as="li">DHCP ativado</ListGroup.Item>
                                                    <ListGroup.Item as="li">Conexão com ONU na WAN do roteador</ListGroup.Item>
                                                    <ListGroup.Item as="li">Teste de velocidade Wifi realizados em bancada 50 megas</ListGroup.Item>
                                                    <ListGroup.Item as="li"><Card.Link href="https://emulator.tp-link.com/c20-v5-br/index.htm" target="_blank">Emulador</Card.Link></ListGroup.Item>
                                                </ListGroup>
                                            </Modal.Body>
                                            <Modal.Footer>
                                                <Button variant="dark" onClick={handleCloseModalB}>
                                                    Fechar
                                                </Button>
                                            </Modal.Footer>
                                        </Modal>
                                        <Card.Link href="https://static.tp-link.com/2018/201810/20181022/Archer%20C20(EU&US)5.0_datasheet.pdf" target="_blank"> <Button variant="dark">Especificações Técnicas </Button> </Card.Link>
                                    </Card.Body>
                                </Card>
                            </div>
                        </div>
                        <div className='row  py-4'>
                            <div className='col-sm-12 col-md-6'>
                                <Card>
                                    <Card.Header className="w-100"><AiIcons.AiFillSignal /> TP-Link 1200 Wireless Dual Band Router EC220-G5</Card.Header>
                                    <Card.Body>
                                        <Card.Title><FaIcons.FaStackOverflow /> Informações básicas: </Card.Title>
                                        <Card.Text>
                                            <div className='router'>
                                                <span className='imagem'><img src={Tplink1200} alt="Foto" /></span>
                                                <span className='marca'>
                                                    <ul>
                                                        <li>Indicado para velocidade de conexões até 1Gbps(rede cabeada)</li>
                                                        <li>Gigabit Ethernet: 1 Porta WAN, 3 Portas LAN RJ-45 10/100/1000Mbps.</li>
                                                        <li>Adaptador AC: 12V/1.0A</li>
                                                        <li>Dual Signal Rate: 5GHz e 2.4GHz</li>
                                                    </ul>
                                                </span>
                                            </div>
                                        </Card.Text>
                                        <Button onClick={handleOpenModal1}>+ Informações</Button>
                                        <Modal show={showModal1} onHide={handleCloseModal1} size="lg" className="custom-modal">
                                            <Modal.Header closeButton>
                                                <Modal.Title>Informações úteis sobre roteador TP-Link C20 com PRESET</Modal.Title>
                                            </Modal.Header>
                                            <Modal.Body>
                                                <ListGroup as="ol">
                                                    <ListGroup.Item as="li">IP padrão: 192.168.0.1</ListGroup.Item>
                                                    <ListGroup.Item as="li">Usuário: int123 | senha: int123</ListGroup.Item>
                                                    <ListGroup.Item as="li">Wi-fi: TP-Link_DF56</ListGroup.Item>
                                                    <ListGroup.Item as="li">Senha: 50055524</ListGroup.Item>
                                                    <ListGroup.Item as="li">Wi-fi: TP-Link_DF56_5G</ListGroup.Item>
                                                    <ListGroup.Item as="li">Senha: 50055524</ListGroup.Item>
                                                </ListGroup>
                                                <br />
                                                <h5>Recomendações:</h5>
                                                <ListGroup as="ol">
                                                    <ListGroup.Item as="li">DHCP ativado</ListGroup.Item>
                                                    <ListGroup.Item as="li">Conexão com ONU na WAN do roteador</ListGroup.Item>
                                                    <ListGroup.Item as="li">Teste de velocidade Wifi realizados em bancada 50 megas</ListGroup.Item>
                                                </ListGroup>
                                            </Modal.Body>
                                            <Modal.Footer>
                                                <Button variant="dark" onClick={handleCloseModal1}>
                                                    Fechar
                                                </Button>
                                            </Modal.Footer>
                                        </Modal>
                                        <Card.Link href="https://www.tp-link.com/br/service-provider/wifi-router/ec220-g5/#specifications" target="_blank"> <Button variant="dark">Especificações Técnicas </Button> </Card.Link>
                                    </Card.Body>
                                </Card>
                            </div>
                            <div className='col-sm-12 col-md-6'>
                                <Card>
                                    <Card.Header className="w-100"><AiIcons.AiFillSignal /> ZTE Multilaser ZXHN H199A AC1200 Dual Band Gigabit</Card.Header>
                                    <Card.Body>
                                        <Card.Title><FaIcons.FaStackOverflow /> Informações básicas: </Card.Title>
                                        <Card.Text>
                                            <div className='router'>
                                                <span className='imagem'><img src={Zte} alt="Foto" /></span>
                                                <span className='marca'>
                                                    <ul>
                                                        <li>Indicado para velocidade de conexões até 1Gbps (rede cabeada) </li>
                                                        <li>Gigabit Ethernet: 1 Porta WAN, 3 Portas LAN RJ-45 10/100/1000Mbps.</li>
                                                        <li>Adaptador AC: 12V DC, 1A </li>
                                                        <li>EasyMesh, integrado com NetSphereTM</li>
                                                    </ul>
                                                </span>
                                            </div>
                                        </Card.Text>
                                        <Button onClick={handleOpenModal2}>+ Informações </Button>
                                        <Modal show={showModal2} onHide={handleCloseModal2} size="lg" className="custom-modal">
                                            <Modal.Header closeButton>
                                                <Modal.Title>Informações úteis sobre roteador ZTE</Modal.Title>
                                            </Modal.Header>
                                            <Modal.Body>
                                                <ListGroup as="ol">
                                                    <ListGroup.Item as="li"><strong>Roteador de Aluguel</strong></ListGroup.Item>
                                                    <ListGroup.Item as="li">IP padrão: 192.168.5.1</ListGroup.Item>
                                                    <ListGroup.Item as="li">Usuário: user | senha: gpaUR32a@22</ListGroup.Item>
                                                    <ListGroup.Item as="li">Wi-fi: Entiqueta embaixo do roteador </ListGroup.Item>
                                                    <ListGroup.Item as="li">Senha: Entiqueta embaixo do roteador</ListGroup.Item>
                                                </ListGroup>
                                                <ListGroup as="ol">
                                                    <ListGroup.Item as="li"><strong>Roteador de Venda</strong></ListGroup.Item>
                                                    <ListGroup.Item as="li">IP padrão: 192.168.10.1</ListGroup.Item>
                                                    <ListGroup.Item as="li">Usuário: user | senha: user</ListGroup.Item>
                                                    <ListGroup.Item as="li">Wi-fi: Entiqueta embaixo do roteador </ListGroup.Item>
                                                    <ListGroup.Item as="li">Senha: Entiqueta embaixo do roteador</ListGroup.Item>
                                                </ListGroup>
                                                <br />
                                                <h5>Recomendações:</h5>
                                                <ListGroup as="ol">
                                                    <ListGroup.Item as="li">DHCP ativado</ListGroup.Item>
                                                    <ListGroup.Item as="li">Conexão com ONU na WAN do roteador</ListGroup.Item>
                                                    <ListGroup.Item as="li">Teste de velocidade Wifi realizados em bancada 50 megas</ListGroup.Item>
                                                </ListGroup>
                                            </Modal.Body>
                                            <Modal.Footer>
                                                <Button variant="dark" onClick={handleCloseModal2}>
                                                    Fechar
                                                </Button>
                                            </Modal.Footer>
                                        </Modal>
                                        <Card.Link href="https://mkt.multilaser.com.br/emkt/mkt/2021/Datasheet_MultilaserPRO/RE942/re942_lamina.pdf" target='_blank'> <Button variant="dark">Especificações Técnicas</Button> </Card.Link>
                                    </Card.Body>
                                </Card>
                            </div>
                        </div>
                        <div className='row  py-2'>
                            <div className='col-sm-12 col-md-6'>
                                <Card>
                                    <Card.Header className="w-100"><AiIcons.AiFillSignal /> Roteador Huawei Ac Ws5200 V2 Ac1200 Gigabit Dual Band</Card.Header>
                                    <Card.Body>
                                        <Card.Title><FaIcons.FaStackOverflow />  Informações básicas: </Card.Title>
                                        <Card.Text>
                                            <div className='router'>
                                                <span className='imagem'><img src={Huawei} alt="Foto" /></span>
                                                <span className='marca'>
                                                    <ul>
                                                        <li>Indicado para velocidade de conexões até 1Gbps (rede cabeada)</li>
                                                        <li>Gigabit Ethernet: 1 Porta WAN, 3 Portas LAN RJ-45 10/100/1000Mbps.</li>
                                                        <li>Adaptador AC: 12V DC, 1A </li>
                                                        <li>Processador Dual-core 1.2G, 128 MB DRAM + 128 MB Flash</li>
                                                    </ul>
                                                </span>
                                            </div>
                                        </Card.Text>
                                        <Button onClick={handleOpenModal3}>+ Informações </Button>
                                        <Modal show={showModal3} onHide={handleCloseModal3} size="lg" className="custom-modal">
                                            <Modal.Header closeButton>
                                                <Modal.Title>Informações úteis sobre roteador Huawei Ws5200</Modal.Title>
                                            </Modal.Header>
                                            <Modal.Body>
                                                <ListGroup as="ol">
                                                    <ListGroup.Item as="li">IP padrão: 192.168.1.1</ListGroup.Item>
                                                    <ListGroup.Item as="li">Usuário: admin | senha: admin</ListGroup.Item>
                                                    <ListGroup.Item as="li">Wi-fi: na etiqueta em baixo do roteador</ListGroup.Item>
                                                    <ListGroup.Item as="li">Senha: na etiqueta em baixo do roteador</ListGroup.Item>
                                                </ListGroup>
                                                <br />
                                                <h5>Recomendações:</h5>
                                                <ListGroup as="ol">
                                                    <ListGroup.Item as="li">DHCP ativado</ListGroup.Item>
                                                    <ListGroup.Item as="li">Conexão com ONU na WAN do roteador</ListGroup.Item>
                                                </ListGroup>
                                                <span>
                                                    Obs. Segundo o fabricante do roteador Huawei, 64 é o máximo dispositivos podem se conectar à rede Wi-Fi do roteador ao mesmo tempo, 32 dispositivos na banda 2.4G + 32 na 5G. A nossa recomendação é de 30 dispositivo conectados simultaneamente para garantir uma margem segura.
                                                </span>
                                            </Modal.Body>
                                            <Modal.Footer>
                                                <Button variant="dark" onClick={handleCloseModal3}>
                                                    Fechar
                                                </Button>
                                            </Modal.Footer>
                                        </Modal>
                                        <Card.Link href="https://www.tecwi.com.br/donwload/produto/huawei/Manual-ws5200.pdf" target='blank'> <Button variant="dark">Especificações Técnicas</Button></Card.Link>
                                    </Card.Body>
                                </Card>
                            </div>
                            <div className='col-sm-12 col-md-6'>
                                <Card>
                                    <Card.Header className="w-100"><AiIcons.AiFillSignal /> Greatek GWR-1200AC GIGABIT</Card.Header>
                                    <Card.Body>
                                        <Card.Title><FaIcons.FaStackOverflow />  Informações básicas: </Card.Title>
                                        <Card.Text>
                                            <div className='router'>
                                                <span className='imagem'><img src={Greatek} alt="Foto" /></span>
                                                <span className='marca'>
                                                    <ul>
                                                        <li>Indicado para velocidade de conexões até 1Gbps (rede cabeada) </li>
                                                        <li>Gigabit Ethernet: 1 Porta WAN, 3 Portas LAN RJ-45 10/100/1000Mbps.</li>
                                                        <li>Adaptador AC: 12V DC, 1A </li>
                                                        <li>Rede MESH</li>
                                                    </ul>
                                                </span>
                                            </div>
                                        </Card.Text>
                                        <Button onClick={handleOpenModal4}>+ Informações</Button>
                                        <Modal show={showModal4} onHide={handleCloseModal4} size="lg" className="custom-modal">
                                            <Modal.Header closeButton>
                                                <Modal.Title>Greatek GWR-1200AC GIGABIT</Modal.Title>
                                            </Modal.Header>
                                            <Modal.Body>
                                                <ListGroup as="ol">
                                                    <ListGroup.Item as="li"><strong>Roteador de Aluguel</strong></ListGroup.Item>
                                                    <ListGroup.Item as="li">IP padrão: 192.168.5.1</ListGroup.Item>
                                                    <ListGroup.Item as="li">Usuário: admin | senha: admin</ListGroup.Item>
                                                    <ListGroup.Item as="li">Wi-fi: Greatek-0ACC69-2.4G | Greatek-0ACC69-5G</ListGroup.Item>
                                                    <ListGroup.Item as="li">Senha: super123</ListGroup.Item>
                                                </ListGroup>
                                                <ListGroup as="ol">
                                                    <ListGroup.Item as="li"><strong>Roteador de Venda</strong></ListGroup.Item>
                                                    <ListGroup.Item as="li">IP padrão: 192.168.10.1</ListGroup.Item>
                                                    <ListGroup.Item as="li">Usuário: admin | senha: admin</ListGroup.Item>
                                                    <ListGroup.Item as="li">Wi-fi: Greatek-0ACC69-2.4G | Greatek-0ACC69-5G</ListGroup.Item>
                                                    <ListGroup.Item as="li">Senha: super123</ListGroup.Item>
                                                </ListGroup>
                                            </Modal.Body>
                                            <Modal.Footer>
                                                <Button variant="dark" onClick={handleCloseModal4}>
                                                    Fechar
                                                </Button>
                                            </Modal.Footer>
                                        </Modal>
                                        <Card.Link href="http://greatek.institucional.ws/wp-content/uploads/2021/09/dsheet_GWR-1200AC.pdf" target='blank'> <Button variant="dark">Especificações Técnicas</Button> </Card.Link>
                                    </Card.Body>
                                </Card>
                            </div>
                        </div>
                        <div className='row  py-2'>
                            <div className='col-sm-12 col-md-6'>
                                <Card>
                                    <Card.Header className="w-100"><AiIcons.AiFillSignal /> Datacom</Card.Header>
                                    <Card.Body>
                                        <Card.Title><FaIcons.FaStackOverflow />  Informações básicas: </Card.Title>
                                        <Card.Text>
                                            <div className='router'>
                                                <span className='imagem'><img src={Datacom} alt="Foto" /></span>

                                                <span className='marca'>
                                                    <ul>
                                                        <li>Indicado para velocidade de conexões até 1Gbps (rede cabeada) </li>
                                                        <li>Gigabit Ethernet: 1 Porta WAN, 4 Portas LAN RJ-45 10/100/1000Mbps.</li>
                                                        <li>Adaptador AC: 12V DC, 1A </li>
                                                        <li>Rede MESH</li>
                                                    </ul>
                                                </span>
                                            </div>
                                        </Card.Text>
                                        <Button onClick={handleOpenModal5}>+ Informações </Button>
                                        <Modal show={showModal5} onHide={handleCloseModal5} size="lg" className="custom-modal">
                                        <Modal.Header closeButton>
                                                <Modal.Title>Informações úteis sobre roteador Datacom</Modal.Title>
                                            </Modal.Header>
                                            <Modal.Body>
                                                <ListGroup as="ol">
                                                    <ListGroup.Item as="li">IP padrão: 192.168.80.1</ListGroup.Item>
                                                    <ListGroup.Item as="li">Usuário e senha: Na etiqueta</ListGroup.Item>
                                                    <ListGroup.Item as="li">Wi-fi 2.4G: Na etiqueta</ListGroup.Item>
                                                    <ListGroup.Item as="li">Senha: Na etiqueta</ListGroup.Item>
                                                    <ListGroup.Item as="li">Wi-fi 5G: Na etiqueta</ListGroup.Item>
                                                    <ListGroup.Item as="li">Senha: Na etiqueta</ListGroup.Item>
                                                </ListGroup>
                                                <br />
                                                <h5>Recomendações:</h5>
                                                <ListGroup as="ol">
                                                    <ListGroup.Item as="li">Este roteador não tem PRESET</ListGroup.Item>
                                                    <ListGroup.Item as="li">Configuração padrão</ListGroup.Item>
                                                    <ListGroup.Item as="li"><Card.Link href="https://simulator.tendacn.com/AC8v2.0/index.html" target="_blank">Emulador</Card.Link></ListGroup.Item>
                                                </ListGroup>
                                            </Modal.Body>
                                            <Modal.Footer>
                                                <Button variant="dark" onClick={handleCloseModal6}>
                                                    Fechar
                                                </Button>
                                            </Modal.Footer>
                                        </Modal>
                                        <Card.Link href="https://www.datacom.com.br/uploads/product/file/6c0718736c584d3b2b3cf3b52e05249f.pdf" target='_blank'> <Button variant="dark">Especificações Técnicas</Button></Card.Link>
                                    </Card.Body>
                                </Card>
                            </div>
                            <div className='col-sm-12 col-md-6'>
                                <Card>
                                    <Card.Header className="w-100"><AiIcons.AiFillSignal /> Tenda</Card.Header>
                                    <Card.Body>
                                        <Card.Title><FaIcons.FaStackOverflow />  Informações básicas: </Card.Title>
                                        <Card.Text>
                                            <div className='router'>
                                                <span className='imagem'><img src={Tenda} alt="Foto" /></span>

                                                <span className='marca'>
                                                    <ul>
                                                        <li>Indicado para velocidade de conexões até 1Gbps (rede cabeada) </li>
                                                        <li>Gigabit Ethernet: 1 Porta WAN, 3 Portas LAN RJ-45 10/100/1000Mbps.</li>
                                                        <li>Até 60 dispositivos conectados simultaneamente segundo o fabricante, mas essa quantidade depende de cada cenário.</li>
                                                        <li>Adaptador AC: 9V DC, 1A </li>
                                                        <li>Rede MESH</li>
                                                    </ul>
                                                </span>
                                            </div>
                                        </Card.Text>
                                        <Button onClick={handleOpenModal6}>+ Informações </Button>
                                        <Modal show={showModal6} onHide={handleCloseModal6} size="lg" className="custom-modal">
                                            <Modal.Header closeButton>
                                                <Modal.Title>Informações úteis sobre roteador Tenda</Modal.Title>
                                            </Modal.Header>
                                            <Modal.Body>
                                                <ListGroup as="ol">
                                                    <ListGroup.Item as="li">IP padrão: 192.168.0.1</ListGroup.Item>
                                                    <ListGroup.Item as="li">Usuário e senha: definir no primeiro acesso</ListGroup.Item>
                                                    <ListGroup.Item as="li">Wi-fi 2.4G: Na etiqueta</ListGroup.Item>
                                                    <ListGroup.Item as="li">Senha: Na etiqueta</ListGroup.Item>
                                                    <ListGroup.Item as="li">Wi-fi 5G: Na etiqueta</ListGroup.Item>
                                                    <ListGroup.Item as="li">Senha: Na etiqueta</ListGroup.Item>
                                                </ListGroup>
                                                <br />
                                                <h5>Recomendações:</h5>
                                                <ListGroup as="ol">
                                                    <ListGroup.Item as="li">Este roteador não tem PRESET</ListGroup.Item>
                                                    <ListGroup.Item as="li">Configuração padrão</ListGroup.Item>
                                                    <ListGroup.Item as="li"><Card.Link href="https://simulator.tendacn.com/AC8v2.0/index.html" target="_blank">Emulador</Card.Link></ListGroup.Item>
                                                </ListGroup>
                                            </Modal.Body>
                                            <Modal.Footer>
                                                <Button variant="dark" onClick={handleCloseModal6}>
                                                    Fechar
                                                </Button>
                                            </Modal.Footer>
                                        </Modal>
                                        <Card.Link href="https://www.tendacn.com/br/product/specification/ac10.html" target='blank'> <Button variant="dark">Especificações Técnicas</Button></Card.Link>
                                    </Card.Body>
                                </Card>
                            </div>
                        </div>
                    </div>
                </Card.Body>
            </Card>

            <div className="end"></div>
        </>
    )
}
export default Especificacoes;